import { useEffect, useMemo } from 'react';

import { useRouter } from 'next/router';

import { Header } from '~/layouts/private/components/Header';
import { useQuery } from '@tanstack/react-query';

import { getPublicBusinessBySlug } from '~/common/services/controllers/business';
import { PrivateLayoutProvider } from '~/common/providers/private-layout';
import { usePlatformAuth } from '~/common/providers/platform-auth';
import { useBusiness } from '~/common/providers/business';
import { IFCWithChildren } from '~/common/interfaces/i-fc-with-children';
import { useMediaQuery } from '~/common/hooks/use-media-query';

const PLATFORM_BUSINESS_SLUG = 'vmcore';

export const AdminLayout: IFCWithChildren = ({ children }) => {
  const router = useRouter();
  const isMobile = useMediaQuery('(max-width: 750px)');
  const { user, isLoading, logout } = usePlatformAuth();
  const { setBusiness } = useBusiness();

  // Aplica a identidade (cor primaria/logo) da propria instancia VMCORE nas
  // telas da plataforma (/admin), igual ao PublicLayout faz com o negocio do
  // slug. Assim /admin nunca herda o tema de outra instancia (ex.: monteiro).
  const { data: platformBusiness } = useQuery({
    queryKey: ['public-business', PLATFORM_BUSINESS_SLUG],
    queryFn: async () => getPublicBusinessBySlug(PLATFORM_BUSINESS_SLUG),
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (platformBusiness) {
      setBusiness(platformBusiness);
    }
  }, [platformBusiness, setBusiness]);

  const shouldRenderHeader = useMemo(() => {
    if (router.asPath === '/admin') {
      return false;
    }

    return !isLoading && Boolean(user);
  }, [isLoading, router.asPath, user]);

  return (
    <PrivateLayoutProvider isMobile={isMobile}>
      {shouldRenderHeader && (
        <Header
          hideNotifications
          forceLogo
          platformLogo
          disableSidebarMenu
          hideUserProfileItem
          showInlineLogoutButton
          userOverride={{
            name: user?.login,
            profile: {
              name: 'Administrador da Plataforma',
            },
          }}
          onLogoutOverride={logout}
        />
      )}
      {children}
    </PrivateLayoutProvider>
  );
};
